import FetchInterceptor from "configs/FetchInterceptor";

class OtherReceivablesServices {
  static async getAll(requestBody) {
    const apiUrl = "/core/v1/sales/other-customer-account/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async add(requestBody) {
    const apiUrl = "/core/v1/sales/other-customer-account/add";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getById(id) {
    const apiUrl = `/core/v1/sales/other-customer-account/get/${id}`;
    const response = await FetchInterceptor.get(apiUrl);
    return response;
  }

  static async getPdf(id) {
    const apiUrl = `/core/v1/sales/other-customer-ccount/get/pdf/${id}`;
    const response = await FetchInterceptor.get(apiUrl, {
      responseType: "blob",
    });
    return response;
  }
}

export default OtherReceivablesServices;
